import {CustomFilterProps, useGridFilter} from 'ag-grid-react';
import {Chips, Separator, TextInput, useTranslationContext} from 'platform/components';
import {HStack, VStack} from 'platform/foundation';

import {intersection} from 'ramda';
import {isEmptyArray} from 'ramda-adjunct';

import {suffixTestId, TestIdProps} from 'shared/web';

import {quickFiltersConst} from '../../constants/quickFilters';
import {useFilterOnChipsChange} from '../../hooks/useFilterOnChipsChange';
import {QuickFilters} from '../../types/Api';
import {getFilterFieldName} from '../../utils/getFilterFieldName';

export type TextFilterProps = {
  isDisabled: boolean;
} & CustomFilterProps &
  QuickFilters &
  TestIdProps;

export function TextFilter(props: TextFilterProps) {
  const t = useTranslationContext();

  const onChange = (changeValue: string | null) => {
    props.onModelChange(changeValue);
  };

  useGridFilter({
    doesFilterPass: () => true,
  });

  const {onChipsChange} = useFilterOnChipsChange({
    setFilterValue: onChange,
    defaultValue: null,
  });

  const isQuickFilterValue = intersection([props.model], quickFiltersConst) as string[];

  return (
    <VStack>
      {props.quickFilters && props.quickFilters.length > 0 && (
        <>
          <HStack>
            <Chips
              isDisabled={props.isDisabled}
              value={isQuickFilterValue}
              options={props.quickFilters}
              onChange={onChipsChange}
              isMultiple={false}
              data-testid={suffixTestId('text-filter-quickFilters', props)}
              isDeselectable
            />
          </HStack>
          <Separator />
        </>
      )}
      <TextInput
        placeholder={t('page.datagrid.filter.textPlaceholder', {
          field: getFilterFieldName(props.column),
        })}
        value={isEmptyArray(isQuickFilterValue) ? props.model : null}
        onChange={onChange}
        isDisabled={props.isDisabled}
        data-testid={suffixTestId('text-filter', props)}
      />
    </VStack>
  );
}
